var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SrButton',{attrs:{"type":"light-blue","href":_vm.downloadUrl}},[_vm._v(" Download Excel Template ")])
}
var staticRenderFns = []

export { render, staticRenderFns }